import styled from 'styled-components';

const ClearDiv = styled.div`
  clear: both;
`;

ClearDiv.displayName = 'ClearDiv';

export default ClearDiv;
